import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    ChangeAccountSettings,
    ChangeProjectSettings,
    updateAccountSettings,
    updateProjectSettings,
} from "client/store"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    Collapse,
    PageForm,
    CheckButton,
} from "client/components"


const SessionFields = () => {
    const accountSettings = useSelector((state: StoreType) => state.accountSettings.settings)
    const projectSettings = useSelector((state: StoreType) => state.projectSettings.settings)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [opened, setOpened] = useState(true)

    const settings = project.id ? projectSettings : accountSettings
    const { sessionFields } = settings.study

    const onChangeAccountSettings = (value: ChangeAccountSettings) => {
        dispatch(updateAccountSettings("study", value))
    }
    const onChangeProjectSettings = (value: ChangeProjectSettings) => {
        dispatch(updateProjectSettings("study", value))
    }

    type StudySessionFieldsType = keyof typeof sessionFields
    const fields: StudySessionFieldsType[] = [
        "facilitator",
        "scribe",
        "comment",
    ]

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    return (
        <Collapse
            show={opened}
            title={lang.sessionFields}
            onCollapse={() => setOpened(!opened)}
        >
            <PageForm>
                <Row>
                    <Col xs={12}>
                        {
                            fields.map((field) => (
                                <CheckButton
                                    key={field}
                                    readOnly={!editAccess}
                                    checked={sessionFields[field]}
                                    title={lang[field]}
                                    onChange={() => {
                                        const newSessionFields: typeof sessionFields = {
                                            ...sessionFields,
                                            [field]: !sessionFields[field],
                                        }
                                        if (project.id) onChangeProjectSettings({ sessionFields: newSessionFields })
                                        else onChangeAccountSettings({ sessionFields: newSessionFields })
                                    }}
                                />
                            ))
                        }
                    </Col>
                </Row>
            </PageForm>
        </Collapse>
    )
}
export default SessionFields
